// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MnaH","label":"styles_label__hD1RB"};